import React from 'react';
import './Timeline.css';

const Timeline = () => {
  const timelineData = [
    {
      year: "2005",
      title: "Starting - Prashanti Nagar",
      subtitle: "Manufacturing Unit",
      description: "The journey begins with the establishment of our first manufacturing unit at Prashanti Nagar. This marked the foundation of our commitment to delivering quality products. With the vision of becoming a key player in the industry, this was the first step towards a remarkable growth trajectory.",
      image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=800&q=80"
    },
    {
      year: "2008",
      title: "Nagole Plant",
      subtitle: "Manufacturing Unit - White Cement",
      description: "In 2008, we expanded our production capabilities with the launch of the Nagole Plant dedicated to manufacturing white cement. This facility enhanced our production capacity, marking our entry into specialized building materials with a focus on high-quality, aesthetically superior products.",
      image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80"
    },
    {
      year: "2010",
      title: "Pachamailaram",
      subtitle: "Manufacturing Unit - Emulsions",
      description: "Our expansion continued with the opening of the Pachamailaram Unit in 2010, dedicated to manufacturing emulsions. This step diversified our product offerings, catering to the growing demand for innovative coatings and construction solutions, and solidified our position in the industry.",
      image: "https://images.unsplash.com/photo-1513467535987-fd81bc7d62f8?w=800&q=80"
    },
    {
      year: "2013",
      title: "Dachapally Unit",
      subtitle: "Manufacturing Unit - Raw Materials/Textures",
      description: "The Dachapally Unit was inaugurated in 2013 to produce raw materials and textures. This strategic expansion provided us with greater control over our supply chain and the ability to produce high-quality materials for the evolving construction market.",
      image: "https://images.unsplash.com/photo-1590846406792-0adc7f938f1d?w=800&q=80"
    },
    {
      year: "2016",
      title: "Vizag Plant",
      subtitle: "Andhra Pradesh Supply",
      description: "Our vision to serve a wider geographic area took shape with the establishment of the Vizag Plant in Andhra Pradesh in 2016. This key facility enabled us to efficiently supply products across a broader region, meeting the growing demand for construction materials in the south of India.",
      image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80"
    },
    {
      year: "2018",
      title: "Market Development",
      subtitle: "",
      description: "By 2018, we had made significant strides in market development, establishing a stronger presence across the nation. Our efforts to expand both our product range and geographical footprint allowed us to reach more customers and improve the quality of construction products available to the market.",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80"
    },
    {
      year: "2021",
      title: "R&D Lab Introduced",
      subtitle: "Premium Products",
      description: "In 2021, we took a significant leap forward by introducing a dedicated R&D Lab focused on creating premium products. This innovation hub enables us to stay ahead of industry trends, developing cutting-edge solutions for the most demanding projects and ensuring superior quality across our product lines.",
      image: "https://images.unsplash.com/photo-1532094349884-543bc11b234d?w=800&q=80"
    },
    {
      year: "2023",
      title: "Tinting Machines",
      subtitle: "Introduced Company Outlets",
      description: "2023 marked a transformative year as we introduced Tinting machines to elevate our product offering. We also launched company-owned outlets, providing customers with direct access to our full range of products and offering personalized service to meet specific project needs.",
      image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=800&q=80"
    },
    {
      year: "2024",
      title: "Central Plant Under Construction",
      subtitle: "",
      description: "Looking towards the future, our Central Plant is currently under construction and is expected to be a flagship facility for production, research, and distribution. This next-generation plant will further enhance our manufacturing capabilities, enabling us to meet the growing demand and continue our commitment to excellence.",
      image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80"
    }
  ];

  return (
    <div className="timeline-wrapper">
      <div className="timeline-header-section">
        <h1 className="timeline-main-heading">Our Journey</h1>
        <p className="timeline-main-subtitle">From our humble beginnings to becoming a leading force in the paint and construction industry</p>
      </div>
      
      <div className="timeline-container">
        <div className="timeline-line"></div>
        {timelineData.map((event, index) => (
          <div 
            key={index} 
            className={`timeline-item ${index % 2 === 0 ? 'timeline-left' : 'timeline-right'}`}
          >
            {/* Text content */}
            <div className="timeline-content timeline-text-content">
              <div className="timeline-header">
                <h2 className="timeline-year">{event.year}</h2>
                <h3 className="timeline-title">{event.title}</h3>
                {event.subtitle && (
                  <p className="timeline-subtitle">{event.subtitle}</p>
                )}
              </div>
              <p className="timeline-description">{event.description}</p>
            </div>
            
            <div className="timeline-dot"></div>
            
            {/* Image content on opposite side */}
            {event.image && (
              <div className="timeline-image-content">
                <img 
                  src={event.image} 
                  alt={event.title} 
                  className="timeline-image"
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Timeline;
